import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const KontainerJenis = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [jenisKontainer, setJenisKontainer] = useState('')

    useEffect(() => {
        const getJenis = async () => {
            const response = await masterService.getJenisContainerById(id)
            setJenisKontainer(response.data.jenisCnt)
        }
        getJenis()
    }, [masterService, id])

    return (
        <>
            {jenisKontainer}
        </>
    )
}

export default KontainerJenis